export const durationOptions = [
  { label: '< 5 Minutes', value: '5', min: 0, max: 300 },
  { label: '5-10 Minutes', value: '10', min: 300, max: 600 },
  { label: '10-15 Minutes', value: '15', min: 600, max: 900 },
  { label: '> 15 Minutes', value: '16', min: 900, max: Infinity }
];
export const getAvailableDurations = (videos) => {
  return durationOptions.filter(option =>
    videos?.some(video => 
      video.duration && video.duration >= option.min && video.duration < option.max
    )
  );
};